import { yieldToMain } from 'assets/core/js/common'
import { pushDataLayerBudgetEvent } from 'assets/core/js/page/product/search/filters/datalayer'
import budgetSlider from 'assets/core/js/page/search/budget-slider'
import submitFilterForm from './submit-filter-form'

export default function (): void {
  void (async () => {
    await yieldToMain()
    budgetSlider({
      callbackChange: (value: string) => {
        pushDataLayerBudgetEvent(value)

        submitFilterForm()
      },
    })
  })()
}
